/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { NotificationBaseService } from '../notification-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Token } from '../models/token';

@Injectable({ providedIn: 'root' })
export class NotificationTemplateControllerService extends NotificationBaseService {

  /**
   * Path part for operation notificationTemplateControllerResolveTokens
   */
  static readonly NotificationTemplateControllerResolveTokensPath = '/v1/template/resolve-tokens';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resolveTokens()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveTokens$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: {
}
  }): Observable<StrictHttpResponse<Array<null | Token>>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationTemplateControllerService.NotificationTemplateControllerResolveTokensPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<null | Token>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resolveTokens$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveTokens(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: {
}
  }): Observable<Array<null | Token>> {

    return this.resolveTokens$Response(params).pipe(
      map((r: StrictHttpResponse<Array<null | Token>>) => r.body as Array<null | Token>)
    );
  }

}
